import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui';
import ccLogo from '../assets/cc-logo.png';

export default function LandingScreen() {
  const navigate = useNavigate();

  return (
    <div className="safe-pt flex flex-col min-h-screen p-6 pt-8 screen-enter">
      {/* Top bar */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full bg-[var(--primary)] shadow-[0_0_0_3px_rgba(255,255,255,0.4)] dark:shadow-[0_0_0_3px_rgba(0,0,0,0.4)]" />
          <span className="text-xs font-medium text-[color:var(--muted-foreground)]">Capitol Commons</span>
        </div>
        <button
          onClick={() => navigate('/citizen/login')}
          className="text-xs font-medium text-[color:var(--muted-foreground)] hover-elevate rounded-md px-2 py-1"
        >
          Sign in →
        </button>
      </div>

      {/* Hero — layered radial gradient halo behind the brand logo */}
      <div className="flex-1 flex flex-col items-center justify-center text-center gap-6">
        <div className="relative w-full max-w-[280px] flex items-center justify-center">
          <div
            className="absolute inset-0 rounded-full blur-3xl opacity-50"
            style={{
              background:
                'radial-gradient(circle at 50% 50%, var(--hero-deep-3), var(--hero-deep) 40%, transparent 65%)',
            }}
          />
          <img src={ccLogo} alt="Capitol Commons" className="relative w-56 h-auto" style={{ mixBlendMode: 'multiply' }} />
        </div>

        <div className="space-y-3 max-w-[300px]">
          <h1 className="text-[2rem] font-extrabold tracking-tight leading-[1.05]">
            Your personal guide to{' '}
            <span
              className="bg-clip-text text-transparent"
              style={{ backgroundImage: 'linear-gradient(135deg, var(--primary), var(--hero-deep-3))' }}
            >
              Colorado politics
            </span>
          </h1>
          <p className="text-[15px] text-[color:var(--muted-foreground)] leading-relaxed">
            Track issues, candidates, and your ballot — built around what matters to you.
          </p>
        </div>

        <div
          className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-semibold"
          style={{ background: 'var(--accent)', color: 'var(--primary)' }}
        >
          <span className="relative inline-flex w-1.5 h-1.5">
            <span className="absolute inset-0 rounded-full bg-current opacity-60 anim-ping" />
            <span className="relative rounded-full bg-current w-1.5 h-1.5" />
          </span>
          Coloradans engaging every week
        </div>
      </div>

      {/* CTAs */}
      <div className="space-y-3 pb-2">
        <Button size="lg" className="w-full" onClick={() => navigate('/citizen/signup')}>
          Get started <ArrowRight className="w-4 h-4" />
        </Button>

        <button
          onClick={() => navigate('/citizen/login')}
          className="w-full text-center text-sm font-medium text-[color:var(--muted-foreground)] hover-elevate rounded-md py-2"
        >
          Already have an account? Sign in
        </button>

        <p className="text-[11px] text-center text-[color:var(--muted-foreground)] pt-2">
          By continuing you agree to the <span className="underline">Citizen Standard</span>.
        </p>
      </div>
    </div>
  );
}
